import React from 'react';

import { CinemaDto } from '@cineamo/api/models/cinema/CinemaDto.types';
import { ShowingDto } from '@cineamo/api/models/showing/ShowingDto.types';

import { PurchaseReasonEnum } from '@cineamo/api/constants/PurchaseReason.enum';

import { formatDistance } from '@cineamo/ui/src/helpers/location-helper';

import CinemaProfileImageRound from '@cineamo/ui/src/image/CinemaProfileImageRound';

import ShowtimesFinderTicketButton from './ShowtimesFinderTicketButton';

const CinemaRow: React.FC<{
    cinema: CinemaDto & {
        showings: ShowingDto[];
    };
    viewType: 'list' | 'map';
    selectedDate: string;
    renderCinemaAction?: (cinema: CinemaDto) => React.ReactNode;
    renderTicketButton?: (showing: ShowingDto, cinema: CinemaDto) => React.ReactNode;
    purchaseReason?: PurchaseReasonEnum;
    showShowingProperties?: boolean;
}> = ({
    cinema,
    viewType,
    selectedDate,
    renderCinemaAction,
    renderTicketButton,
    purchaseReason,
    showShowingProperties
}) => {
    return (
        <div className="py-12 flex flex-col space-y-12 min-w-0">
            <div className="flex flex-row space-x-12 min-w-0">
                <CinemaProfileImageRound
                    cinema={cinema}
                    size={'42'}
                    className="flex-shrink-0"
                />
                <div className="flex flex-col space-y-4 min-w-0 flex-1">
                    <div className="text-body-bold-16 whitespace-nowrap overflow-hidden text-ellipsis">
                        {cinema.name}
                    </div>
                    <div className="text-body-12 flex flex-row space-x-4 whitespace-nowrap overflow-hidden text-ellipsis">
                        <span className="font-bold flex-shrink-0">
                            {cinema.distance ? formatDistance(cinema.distance) : ''}
                        </span>
                        {cinema.distance ? <span className="opacity-70 flex-shrink-0">•</span> : null}
                        <span className="opacity-70 overflow-hidden text-ellipsis">
                            {cinema.street}, {cinema.postalCode} {cinema.city}
                        </span>
                    </div>
                </div>
                {renderCinemaAction?.(cinema)}
            </div>
            <div className="flex flex-row gap-8 flex-wrap">
                {cinema.showings.map((showing) => (
                    <div
                        key={`TicketButton-${showing.id}`}
                        className="flex flex-col space-y-4 flex-shrink-0">
                        {renderTicketButton ? (
                            renderTicketButton(showing, cinema)
                        ) : (
                            <ShowtimesFinderTicketButton
                                showing={showing}
                                cinema={cinema}
                                viewType={viewType}
                                selectedDate={selectedDate}
                                purchaseReason={purchaseReason}
                                showShowingProperties={showShowingProperties}
                            />
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CinemaRow;
